import {fromEvent, merge, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {FrontWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';

/** Creates an Observable that emits events with every document focus state change
 * @param {Window} window (unused on mobile)
 * @returns {Observable<boolean>} An observable emitting true when the document is focused and false when blurred.
 */
export function fromFocusEvent(window: FrontWindow): Observable<boolean> {
  return merge(fromEvent(window, 'focus'), fromEvent(window, 'blur')).pipe(map(() => isFocused(window)));
}

export function isFocused(window: FrontWindow): boolean {
  return window.document.hasFocus();
}
